import React, { useState } from "react";
import "./Roofrepair.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function BuildingRehabilitation() {



  return (

    <div className="Roofrepair-page">
      <div className="Roofrepair-hero">
        <div className="Roofrepair-overlay">
          <h1>  שיקום מבנים </h1>
        </div>
<div>
</div>
</div>
    <div className="page3">
 <div className="breadcrumb3">
  <Link to="/">בית</Link> /{" "}
  <Link to="/ProfessionalInformation"> מידע מקצועי</Link>/{" "}
   <Link to="/BuildingRehabilitation">   שיקום מבנים</Link>{" "}
</div>
    </div>

      {/* CONTENT */}
<div className="page4">
  <div className="container">

    <h2 className="top-text">
שיקום מבנים - תיקון נזקי שריפה, נזילות ועוד הוא תחום מיוחד בענף הבניין מאפשר שיקום של מבנים ישנים, הכשרת המבנים לעמידות בפני נזקים שונים ועוד.
    </h2>

    <div className="content-row">


      <div className="image-box">
        <img src="/images/58.jpeg" alt="roof" />
      </div>
      <div className="text-box">
        נושאים שונים בעולם הבניין נכללים בתחום המקצוע הזה, עבודות כמו הפיכת מבנה לעמיד בפני פגעי מזג אוויר, הפיכת הבניין לבטוח יותר, שיפור ותיקון מערכת המים ועוד. בניינים רבים נבנו ללא איטום מספק, מבנים כאלו עלולים להיות חשופים לנזקי נזילות. נזילות מתרחשות לעתים גם בבניינים ישנים שהלכו והתפוררו עם השנים ואינם מסוגלים לעמוד מול הנזקים של צנרת המים. ניתן לשקם את הבניין שיקום חזותי – חיצוני, שיקום שמשפיע בעיקר על המעטפת החיצונית של הבניין. שיקום קונסטרוקציות נועד כדי לחזק את היסודות ורכיבים שונים שחוו נזקים במהלך השנים שחלפו מאז נבנה הבניין.
      </div>

    </div>


    <div className="bottom-text">

      <p> כמעט אין מי שלא שמע את המושג פינוי – בינוי. חוק פינוי בינוי נחקק בשנת 1965 בישראל, החוק הזה נועד להפוך את הבתים הפרטיים, נמוכי הקומה שאף היו בנויים באופן שאינו בטיחותי מספיק לבתים עירוניים בטוחים תוך כדי שימור העיצוב והחזות החיצונית שלהם, לצורך כך רשמו על כל אבן עתיק מספר כדי לדעת לאן להחזיר אותה, שיקמו את המבנה, שיפצו אותו, תקנו את מה שדרש תיקון וחיפו אותו מחדש באבנים.
במקרים של שריפה במבנה, קריסה של גג או קיר, לאחר פינוי ואמידת האסון, יש צורך להתחיל בעבודות שיקום כדי להחזיר את המבנה לקדמותו. יש לעמוד בקשר עם שמאי שיעריך את אומדן הנזק, כמו כן יש לקבל מידע מחברת הביטוח במקרה שהמבנה היה מבוטח כדי לקבל את הפיצויים הכספיים שיסייעו בעבודות השיקום של המבנה. למקרים כאלו, רצוי שיהיה בידכם ביטוח על המבנה, לא ניתן לדעת איפה זה עתיד לקרות, כדאי לבטח את עצמכם. </p>
 <h2 className="main-title">
כל מבנה ניזוק באזורים אחרים ובתחומים שונים ממבנה אחר:


    </h2>




      <p>  נזק במערכות הצנרת - איתור נזילות ורטיבות, השיקום ייעשה במערכות הצנרת ובאזורים בהם ישנם צינורות עיקריים, אם ניזוקו קירות כתוצאה מהנזילה, יש צורך לשקם גם אותם.  </p>
      <p>  נזק בשלד הבניין - יש לשקם את הקונסטרוקציות של המבנה ואף לחזק את היסודות, תקלה כזו היא הנפוצה ביותר במבנים.

 </p>

      <p> נעשה שימוש בחומרים שונים במהלך השיקום של המבנה, יש לוודא שקבלן חברת הבנייה עושה שימוש בחומרים בטוחים ואיכותיים. שיקום מבנים נועד כדי לשפר את המבנה ולתקן את הפגמים שיש בו. </p>




    </div>


     <ContactSection2/>
<div className="links">

  <Link to="/BuildingRehabilitation" className="link-right" > איטום קירות חיצוניים</Link>
  <Link to="/Rooftarps" className="link-left" >  זיפות גגות</Link>

</div>

      </div>
    </div>
  

      </div>
  );
}

